import React, { useState, useEffect, useRef } from "react";

// ANT DESIGN
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Tag,
  Select,
  Button,
  Space,
  Form,
} from "antd";
import {
  SearchOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  ReloadOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/MainLayout";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../components/layouts/TopContent";
import { onSelectItemAction, rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../customer.config";
// import StatusSelect from "../../../components/StatusSelect";
import StatusSelect from "../../../components/CustomStatusSelect";
import CustomPagination from "../../../components/CustomPagination";

//global distructures
const { Text, Link, Title } = Typography;

const ManageCustomer = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;

  const { session } = userData;
  const [customerList, setCustomerList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  // const [perPage, setPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isSearch, setIsSearch] = React.useState(1);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const columns = [
    {
      title: labelConfig.clientId,
      dataIndex: "clientno",
      sorter: (a, b) => a["clientno"].localeCompare(b["clientno"]),
    },
    {
      title: labelConfig.name,
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: labelConfig.mobilePhone,
      dataIndex: "mobileNo",
    },
    {
      title: labelConfig.branch,
      dataIndex: "branch",
      sorter: (a, b) => a.branch.localeCompare(b.branch),
    },
    {
      title: labelConfig.relationshipManager,
      dataIndex: "staff",
    },
    {
      title: labelConfig.status,
      dataIndex: "status",
      render: (_, record) => {
        return <Text> {handleFlgStatus(record?.status, {}, true)}</Text>;
      },
    },
  ];

  //DECLARED METHODS

  useEffect(() => {
    console.log(BOM.HasPermission("READ_CLIENT"));
    BOM.HasPermission("READ_CLIENT") && getCustomerListAction();
    BOM.HasPermission("CREATE_CLIENT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getCustomerListAction = (offset = 0, limit = Number(tableCount)) => {
    console.log(limit, offset);
    const params = {
      limit: limit,
      offset: offset,
      orderBy: "id",
      // status: 100,
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    setIsSearch(false);
    BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // console.log(" i ran");
        setIsLoading(false);
        setTotalItems(res?.totalFilteredRecords);
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          const statusValue = element?.status ? element?.status.value : "-";
          tempArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.displayName ? element?.displayName : "-",
            clientno: element?.accountNo ? element?.accountNo : "-",
            mobileNo: element?.mobileNo ? element?.mobileNo : "-",
            // status: element?.status ? element?.status.value : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
            branch: element?.officeName ? element?.officeName : "-",
            staff: element?.staffName ? element?.staffName : "-",
            branchId: element?.officeId ? element?.officeId : "-",
          });
        });
        console.log(tempArray);

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setCustomerList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        orderBy: "id",
      };
      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            const statusValue = element?.status ? element?.status.value : "-";
            tempArray.push({
              key: element?.id,
              id: element?.id,
              name: element?.displayName ? element?.displayName : "-",
              clientno: element?.accountNo ? element?.accountNo : "-",
              mobileNo: element?.mobileNo ? element?.mobileNo : "-",
              // status: element?.status ? element?.status.value : "-",
              status:
                statusValue?.toLowerCase() === "submitted and pending approval"
                  ? "Pending"
                  : statusValue,
              branch: element?.officeName ? element?.officeName : "-",
              staff: element?.staffName ? element?.staffName : "-",
              branchId: element?.officeId ? element?.officeId : "-",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_CLIENT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_CLIENT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  // function handleSearchInTable(searchKey) {
  //   searchKey = searchKey.target.value;

  //   if (!searchKey) {
  //     setCustomerList(originalList);
  //     return;
  //   }
  //   const filterBySearch = originalList.filter(
  //     (item) => item?.key === parseInt(searchKey) || item?.name.toLowerCase()?.includes(searchKey)
  //   );
  //   setCustomerList(filterBySearch);
  // }

  function selectTableCount(value) {
    setTableCount(value);
    onRefresh(0, value);
    console.log(value);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-customer", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-customer", { state: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-customer", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSearch = (formValue) => {
    setIsLoading(true);

    const params = {
      exactMatch: false,
      query: formValue.searchKey,
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };
    setIsSearch(true);
    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];
        setIsLoading(false);

        objList.forEach((element) => {
          const statusValue = element?.entityStatus ? element?.entityStatus.value : "-";
          tempArray.push({
            key: element?.entityId,
            id: element?.entityId,
            name: element?.entityName ? element?.entityName : "-",
            clientno: element?.entityAccountNo ? element?.entityAccountNo : "-",
            mobileNo: element?.entityMobileNo ? element?.entityMobileNo : "-",
            // status: element?.entityStatus ? element?.entityStatus.value : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
            branch: element?.parentName ? element?.parentName : "-",
            branchId: element?.parentId ? element?.parentId : "-",
            staff: element?.staffName ? element?.staffName : "-",
          });
        });

        // //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setCustomerList(tempArray);

        // //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);
        // //STOP LOAD
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    useForm.resetFields();
    getCustomerListAction(offset, limit);
    setCurrentPage(1);
  };

  const handleFlgStatus = (status, style = {}, isListing = false) => {
    switch (status.toLowerCase()) {
      case "active":
        return (
          <Tag
            icon={<CheckCircleOutlined />}
            color={`${isListing ? "success" : "#87D068"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      case "closed":
        return (
          <Tag
            icon={<CloseCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      default:
        return (
          <Tag
            icon={<ClockCircleOutlined />}
            color={`${isListing ? "warning" : "#FFEB86"}`}
            style={{ color: "black", ...style }}
          >
            {BOM.SubstringFormat(status, 21)}
          </Tag>
        );
    }
  };

  //DECLARED METHODS
  // const handleStatusChange = (value) => {
  //   setSelectedStatus(value);
  //   // Your filtering logic here
  // };

  // function handleStatusChange(value) {
  //   setSelectedStatus(value);

  //   let tempList = originalList;

  //   switch (value.toLowerCase()) {
  //     case "status":
  //       tempList = originalList;
  //       break;
  //     case "active":
  //       tempList = originalList.filter(
  //         (item) => item.status.toLowerCase() === "active"
  //       );
  //       break;
  //     case "closed":
  //       tempList = originalList.filter(
  //         (item) => item.status.toLowerCase() === "closed"
  //       );
  //       break;
  //     case "submitted and pending approval":
  //       tempList = originalList.filter(
  //         (item) =>
  //           item.status.toLowerCase() === "submitted and pending approval"
  //       );
  //       break;
  //     default:
  //       tempList = originalList;
  //       break;
  //   }

  //   setCustomerList(tempList);
  // }

  // useEffect(() => {
  //   handleStatusChange("active");
  // }, [originalList]);

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.manageCustomer}
        pageItems={staticConfig.manageBreadcrumbItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={
          <>
            Customer List{" "}
            <Button
              type="primary"
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              onClick={() => onRefresh()}
              icon={<ReloadOutlined />}
              loading={isLoading}
            >
              {labelConfig.refresh}
            </Button>
          </>
        }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <Row style={{ marginLeft: 10 }}>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form form={useForm} onFinish={onSearch}>
                  <Space.Compact
                    style={{
                      width: "100%",
                      // border: "1px solid #d9d9d9",
                    }}
                  >
                    <Form.Item
                      name="searchKey"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("This field "),
                        },
                      ]}
                    >
                      <Input
                        placeholder="Search by Client: Name / ID / Mobile Number"
                        style={{ width: 400 }}
                        allowClear
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      className="of-primaryBtnColor"
                      htmlType="submit"
                      style={{ borderRadius: "0px 5px 5px 0px" }}
                    >
                      <SearchOutlined />
                    </Button>
                    <div style={{ marginLeft: "20px" }}>
                      <StatusSelect
                        statusOptions={staticConfig.customerStatusOptions}
                        originalList={originalList}
                        onFilteredListChange={setCustomerList}
                        statusField="status"
                        defaultStatus={isSearch ? "status" : "active"}
                      />
                    </div>
                  </Space.Compact>
                </Form>
              </Col>
            </Row>
            <DownloadTableButtons
              downloadData={customerList}
              columns={columns}
              fileName="Customer List"
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={customerList}
            bordered
            //
            pagination={false}
            scroll={{ x: 800 }}
          />
          {!isSearch && (
            <CustomPagination
              totalItems={totalItems}
              pageSize={Number(tableCount)}
              onPageChange={(page, offset) => onRefresh(offset)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageCustomer);
